export const FETCH_PIPELINE_BEGIN = "FETCH_PIPELINE_BEGIN";
export const FETCH_PIPELINE_SUCCESS = "FETCH_PIPELINE_SUCCESS";
export const FETCH_PIPELINE_FAILURE = "FETCH_PIPELINE_FAILURE";

   